/**
 * Legacy Axios wrapper — used ONLY by the auth Redux saga.
 * New features must use src/lib/apiClient.ts with TanStack Query.
 */
import axios from "axios";
import { STORAGE, URLS } from "../../_config";

const getToken = () => {
  try {
    const raw = localStorage.getItem(STORAGE);
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.access_token ?? user?.token ?? null;
  } catch {
    return null;
  }
};

const handleUnauthorized = (error) => {
  if (
    error.response &&
    error.response.status === 401 &&
    window.location.pathname !== URLS.AUTH.LOGIN
  ) {
    localStorage.removeItem(STORAGE);
    window.location.href = URLS.AUTH.LOGIN;
  }
};

export class CallApi {
  static GET(url, params) {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    return axios({ method: "GET", url, headers, params }).catch((error) => {
      handleUnauthorized(error);
      return Promise.reject(error.response);
    });
  }

  static POST(url, data) {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    return axios({ method: "POST", url, headers, data }).catch((error) => {
      handleUnauthorized(error);
      return Promise.reject(error.response);
    });
  }

  static PUT(url, data) {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    return axios({ method: "PUT", url, headers, data }).catch((error) => {
      handleUnauthorized(error);
      return Promise.reject(error.response);
    });
  }

  static DELETE(url) {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    return axios({ method: "DELETE", url, headers }).catch((error) => {
      handleUnauthorized(error);
      return Promise.reject(error.response);
    });
  }
}
